import { Link } from 'react-router-dom';
import { motion } from 'framer-motion';
import { PlayIcon } from '@heroicons/react/24/solid';

const HomePage = () => {
  return (
    <div className="min-h-screen bg-gradient-to-b from-black via-zinc-900 to-black text-white overflow-hidden">
      {/* Hero Section */}
      <div className="container mx-auto px-4 md:px-8 pt-16 pb-24">
        <div className="flex flex-col items-center justify-center min-h-[80vh] text-center">
          {/* Logo/Title */}
          <motion.div
            initial={{ opacity: 0, y: -20 }}
            animate={{ opacity: 1, y: 0 }}
            transition={{ duration: 0.8 }}
            className="relative mb-12"
          >
            <h1 className="text-5xl md:text-7xl font-bold bg-gradient-to-r from-pink-500 via-purple-500 to-indigo-500 bg-clip-text text-transparent">
              VibeBox
            </h1>
            <div className="absolute -bottom-2 left-0 w-full h-1 bg-gradient-to-r from-pink-500 via-purple-500 to-indigo-500 rounded-full"></div>
          </motion.div>
          
          {/* Description */}
          <div className="space-y-6 mb-12">
            <motion.p 
              initial={{ opacity: 0 }}
              animate={{ opacity: 1 }}
              transition={{ delay: 0.3, duration: 0.8 }}
              className="text-zinc-300 text-xl md:text-2xl max-w-2xl font-medium"
            >
              Experience the next generation of micro-dramas
            </motion.p>
            
            <motion.p
              initial={{ opacity: 0 }}
              animate={{ opacity: 1 }}
              transition={{ delay: 0.6, duration: 0.8 }}
              className="text-zinc-400 text-base md:text-lg max-w-3xl mx-auto"
            >
              Dive into a world of bite-sized entertainment that packs all the emotion, 
              excitement, and drama you crave. Perfect for your on-the-go lifestyle.
            </motion.p>
          </div>
          
          {/* CTA Buttons */}
          <motion.div
            initial={{ scale: 0.9, opacity: 0 }}
            animate={{ scale: 1, opacity: 1 }}
            transition={{ delay: 0.9, duration: 0.5 }}
            className="flex flex-col sm:flex-row gap-5 mb-12"
          >
            <motion.div
              whileHover={{ scale: 1.05 }}
              whileTap={{ scale: 0.95 }}
            >
              <Link 
                to="/shorts" 
                className="flex items-center justify-center gap-2 px-8 py-4 bg-gradient-to-r from-pink-500 to-purple-600 rounded-full font-bold text-lg shadow-lg shadow-purple-500/30 hover:shadow-purple-500/50 transition-all"
              >
                <PlayIcon className="h-5 w-5" />
                Start Watching
              </Link>
            </motion.div>
            
          </motion.div>
          
          {/* Features */}
          <motion.div 
            initial={{ opacity: 0 }}
            animate={{ opacity: 1 }}
            transition={{ delay: 1.2, duration: 0.8 }}
            className="flex flex-col sm:flex-row items-center justify-center gap-6 text-zinc-500"
          >
            <span className="flex items-center"><span className="w-2 h-2 bg-green-500 rounded-full mr-2"></span>No signup required</span>
            <span className="flex items-center"><span className="w-2 h-2 bg-green-500 rounded-full mr-2"></span>New content daily</span>
          </motion.div>
        </div>
      </div>
    </div>
  );
};

export default HomePage; 